<template>
  <div :id="linkedResource.id" class="linked-resource-container">
    <div class="linked-resource-content">
      <EditorSection
        v-for="section in linkedResource.sections"
        :key="`${section.id}-view`"
        class="top-filler"
        :section-id="section.id"
        :context="Context.DsrTemplate"
        :is-hidden="section.hidden"
        :rows="section.rows"
        :recipient-input="[]"
        :updating-inputs="[]"
        :failed-input-updates="[]"
        :merge-values="mergeValues"
        :block-width-class="blockWidthClass"
        is-linked-resource
        is-dsr
        :mapped-placeholders="mappedPlaceholders"
        :branding="section?.branding"
        :theme="theme"
        @fetch-new-image="
          $emit('fetch-new-linked-image-url', {
            ...$event,
            linkedResourceId: linkedResource.id,
          })
        "
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import type {
  MappedContentPlaceholder,
  LinkedResource,
  LoadLinkedResourceImagePayload,
} from '@getaccept/editor-lib';
import { Context, useEditorFieldsStore, useEditorMetaDataStore } from '@getaccept/editor-lib';
import EditorSection from '@getaccept/editor-view/src/components/EditorSection.vue';
import type { EntityTheme } from '@getaccept/lib-shared/src/branding/types/theme';
import { storeToRefs } from 'pinia';

const { linkedResource } = defineProps<{
  linkedResource: LinkedResource;
  mappedPlaceholders: MappedContentPlaceholder[];
  theme: EntityTheme;
}>();

defineEmits<{ 'fetch-new-linked-image-url': [LoadLinkedResourceImagePayload] }>();

const { mergeValues } = storeToRefs(useEditorFieldsStore());
const { blockWidthClass } = storeToRefs(useEditorMetaDataStore());
</script>
<style lang="scss" scoped>
$linked-resource-background: #eefbfe;

.linked-resource-container {
  position: relative;

  .linked-resource-content {
    padding: var(--spacing-100);
    margin: -2px -1rem;
    background-color: $linked-resource-background;
    border-radius: var(--radius-large);
    border: 2px solid var(--gray-89);
  }
}
</style>
